import { useMutation } from '@tanstack/react-query';

import { useSessionWriter } from '../../shared/session';
import { logout } from './session';

/** Выход: сервер, хранилище, кэш — в этом порядке; кэш чистит писатель сессии. */
export function useLogout() {
  const session = useSessionWriter();
  return useMutation({
    mutationFn: logout,
    onSettled: session.clear,
  });
}
